import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './DocumentLink.css';
import moment from 'moment';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faFilePdf from '@fortawesome/fontawesome-free-regular/faFilePdf';
import faFileWord from '@fortawesome/fontawesome-free-regular/faFileWord';
import faFileExcel from '@fortawesome/fontawesome-free-regular/faFileExcel';
import faFileImage from '@fortawesome/fontawesome-free-regular/faFileImage';
import { getLastTokenFromUrl } from 'services/utils/text-util';

import Button from 'components/shared/button/Button';
import PdfViewerBluebeam from 'components/shared/pdf-viewer-bluebeam/PdfViewerBluebeam';
import { bluebeamApi } from 'services/api/bluebeam-api';

import { getCreatedBluebeamSession } from 'selectors/pdfViewerBluebeam';
import { createdBluebeamSnapshot } from 'actions/pdfViewerBluebeam';

class DocumentLinkBluebeam extends Component {
  static propTypes = {
    file: PropTypes.any,
    showIcon: PropTypes.bool,
    showLink: PropTypes.bool,
    createdBluebeamSession: PropTypes.bool,
    showInModal: PropTypes.bool,
  };

  static defaultProps = {
    file: null,
    showIcon: true,
    showLink: true,
    createdBluebeamSession: false,
    showInModal: true,
  };

  constructor(props) {
    super(props);
    this.state = {
      showDocumentPdfViewer: false,
      pdfUrl: null,
    };
  }

  getName = (props) => {
    let result = 'Unknown';
    if (props.file.url) {
      const name = getLastTokenFromUrl(props.file.url);
      if (name) {
        result = name;
      }
    } else if (props.file) {
      result = props.file.name;
    }
    return result;
  };

  getIcon = (props) => {
    let icon;
    let fileName = '';

    if (props.file.url) {
      const tokens = props.file.url.split('/');
      if (tokens.length > 0) {
        fileName = tokens[tokens.length - 1];
      }
    } else if (props.file !== null) {
      fileName = props.file.name;
    }

    let extension = this.getExtension(fileName);
    switch (extension) {
      case 'pdf':
        icon = (
          <FontAwesomeIcon icon={faFilePdf} style={{ color: '#ff0000' }} />
        );
        break;

      case 'doc':
      case 'docx':
        icon = (
          <FontAwesomeIcon icon={faFileWord} style={{ color: '#0051ff' }} />
        );
        break;

      case 'xls':
      case 'xlsx':
        icon = (
          <FontAwesomeIcon icon={faFileExcel} style={{ color: '#00bd09' }} />
        );
        break;

      case 'jpeg':
      case 'jpg':
      case 'png':
        icon = (
          <FontAwesomeIcon icon={faFileImage} style={{ color: '#eb7d34' }} />
        );
        break;

      default:
        icon = null;
        break;
    }

    return icon;
  };

  getExtension = (fileName) => {
    const fileNameTokes = fileName.split('.');
    if (fileNameTokes.length > 0) {
      return fileNameTokes[fileNameTokes.length - 1].toLowerCase();
    }
  };

  getUrl = () => {
    if (this.props.file.url !== null) {
      return `${this.props.file.url}?time=${moment().unix()}`;
    } else if (
      this.props.file !== null &&
      this.props.file.hasOwnProperty('preview')
    ) {
      return this.props.file.preview;
    } else {
      return null;
    }
  };

  showPdf = () => {
    this.setState({
      pdfUrl: this.getUrl(this.props),
      showDocumentPdfViewer: true,
    });
  };

  handleDocumentPdfViewerClose = () => {
    this.setState({
      pdfUrl: null,
      showDocumentPdfViewer: false,
    });
    if (this.props.createdBluebeamSession) {
      bluebeamApi.generateSnapshot(this.props.file.id);
      this.props.onCreatedBluebeamSnapshot();
    }
  };

  render() {
    const props = this.props;
    const fileName = this.getName(props);
    const extension = this.getExtension(fileName);
    return (
      <React.Fragment>
        <div className="document-link">
          {(!props.file.id || extension !== 'pdf') && (
            <div>
              <a
                className={!props.showLink ? 'not-active' : null}
                href={this.getUrl(props)}
                target="_blank"
                onClick={(event) => event.stopPropagation()} // to use inside SimpleTable (which prevents defaults on tr clicks)
              >
                <div>{this.getName(props)}</div>
              </a>
            </div>
          )}
          {props.file.id && extension === 'pdf' && (
            <Button label={fileName} onClick={this.showPdf} />
          )}
          {props.showIcon && <div>{this.getIcon(props)}</div>}
        </div>

        {props.showInModal && props.file.id && extension === 'pdf' && (
          <React.Fragment>
            <PdfViewerBluebeam
              content={{
                source: this.state.pdfUrl,
                type: 'url',
              }}
              show={this.state.showDocumentPdfViewer}
              onClose={this.handleDocumentPdfViewerClose}
              documentId={props.file.id}
              fileName={fileName}
              pdftronIntegration={true}
              bbIntegration={true}
              blueBeamLink={null}
            />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    createdBluebeamSession: getCreatedBluebeamSession(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onCreatedBluebeamSnapshot: () => {
    dispatch(createdBluebeamSnapshot());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DocumentLinkBluebeam);



// WEBPACK FOOTER //
// ./src/components/shared/document/DocumentLinkBluebeam.js